export const statesGenero = {
    MALE: 1,
    FEMALE: 2
}